import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FlexContainer, FlexCol, FlexRow, Panel, Tabs, SkipNavContent, HelmetWrapper } from 'sarsaparilla';
import SwaggerUIBundle from 'swagger-ui'; // eslint-disable-line
import Documentation from '../components/Documentation';
import { CurrentUserProps } from '../props/currentUser';
import { getCurrentUser } from '../reducers/currentUser';

const propTypes = {
  currentUser: CurrentUserProps,
  route: PropTypes.shape({
    swaggerSpecs: PropTypes.string
  })
};

const defaultProps = {};

const specs = [
  {
    key: 'ridb',
    label: 'RIDB API',
    specs: `${process.env.CDN}/swagger/ridb.yaml`,
    display() {
      return true;
    }
  },
  {
    key: 'data-steward',
    label: 'Data Steward API',
    specs: `${process.env.CDN}/swagger/dataSteward.yaml`,
    display(currentUser) {
      return currentUser.apiKey.writeAccess;
    }
  },
  {
    key: 'availability',
    label: 'Availability API',
    specs: `${process.env.CDN}/swagger/availability.yaml`,
    display(currentUser) {
      return currentUser.apiKey.tier1Access;
    }
  }
];

export class DocumentationPage extends PureComponent {
  // constructor(props) {
  //   super(props);
  //
  //
  //   this.renderSwagger = this.renderSwagger.bind(this);
  // }
  //
  // componentDidMount() {
  //   // this.renderSwagger();
  // }
  //
  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.route.swaggerSpecs !== this.state.specs) {
  //     this.setState((prevState) => ({ ...prevState, specs: nextProps.route.swaggerSpecs }), this.renderSwagger);
  //   }
  // }
  //
  // renderSwagger() {
  //   const swagger = SwaggerUIBundle({
  //     dom_id: '#swagger-docs',
  //     url: this.state.specs,
  //     deepLinking: true,
  //     defaultModelExpandDepth: 2,
  //     defaultModelsExpandDepth: 1,
  //     displayOperationId: true,
  //     supportedSubmitMethods: ['get'],
  //     requestInterceptor: (request) => {
  //       if (request.loadSpec) {
  //         // Intercept the spec and replace the RIDB_HOST with the correct one for the ENV we're running in.
  //         request.responseInterceptor = (response) => {
  //           response.body.servers[0].url = response.body.servers[0].url.replace('RIDB_HOST', process.env.RIDB_ROOT);
  //           response.obj.servers[0].url = response.obj.servers[0].url.replace('RIDB_HOST', process.env.RIDB_ROOT);
  //           response.data = response.data.replace('RIDB_HOST', process.env.RIDB_ROOT);
  //           response.text = response.text.replace('RIDB_HOST', process.env.RIDB_ROOT);
  //
  //           return response;
  //         };
  //       }
  //
  //       return request;
  //     },
  //     onComplete: () => {
  //       // Automatically set the developers ApiKey
  //       setTimeout(() => {
  //         const { isDeveloper, apiKey: { apiKey } } = this.props.currentUser;
  //         if (isDeveloper) {
  //           swagger.preauthorizeApiKey('Apikey', apiKey);
  //         }
  //       }, 10);
  //     }
  //   });
  // }

  render() {
    const { currentUser } = this.props;

    return (
      <SkipNavContent>
        <HelmetWrapper title="RIDB API Documentation" />
        <main role="main">
          <FlexContainer>
            <FlexRow>
              <FlexCol>
                <Tabs indentTabs>
                  {specs.filter((spec) => spec.display(currentUser)).map((spec) => (
                    <Panel label={spec.label} key={spec.key}>
                      <Documentation specs={spec.specs} currentUser={currentUser} />
                    </Panel>
                  ))}
                </Tabs>
              </FlexCol>
            </FlexRow>
            <div id="swagger-docs" />
          </FlexContainer>
        </main>
      </SkipNavContent>
    );
  }
}

DocumentationPage.propTypes = propTypes;
DocumentationPage.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  currentUser: getCurrentUser(state)
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DocumentationPage);
